import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { SmoothScroll } from "./components/SmoothScroll";
import { Header } from "./components/Header";
import { Home } from "./pages/Home";
import { Events } from "./pages/Events";
import { EventDetail } from "./pages/EventDetail";
import { Checkout } from "./pages/Checkout";
import { Confirmation } from "./pages/Confirmation";

function App() {
  return (
    <div className="App">
      <div className="grain-overlay" aria-hidden="true" />
      <BrowserRouter>
        <SmoothScroll>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/events" element={<Events />} />
            <Route path="/events/:slug" element={<EventDetail />} />
            <Route path="/checkout/:slug" element={<Checkout />} />
            <Route path="/confirmation/:id" element={<Confirmation />} />
          </Routes>
        </SmoothScroll>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: { background: "hsl(30 11% 14%)", color: "hsl(40 33% 96%)", border: "none", borderRadius: "4px" },
        }}
      />
    </div>
  );
}

export default App;
